import { createRatesService } from './rate.service';

const ENDPOINT = '/api/enhancement_rates';
const EnhancementRateService = createRatesService(ENDPOINT, 'enhancement_rate');

export default EnhancementRateService;